
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cerez-politikasi",
      function () {
        return require("private-next-pages/cerez-politikasi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cerez-politikasi"])
      });
    }
  